import { course_semester, courses_for_select_student_log_book_selectQuery } from '@app-types/graphql-types';
import _ from 'lodash';
import moment from 'moment';

export const semesterToWords = (semester: string): string => {
  const semesterYear = moment.localeData().ordinal(parseInt(semester.split(':')[0], 10));
  const semesterLabel = moment.localeData().ordinal(parseInt(semester.split(':')[1], 10));

  return `${semesterYear} year ${semesterLabel} semester`;
};

export const orderedSemester = (
  semesters: courses_for_select_student_log_book_selectQuery['course'][0]['course_semesters'],
): courses_for_select_student_log_book_selectQuery['course'][0]['course_semesters'] => {
  return _.sortBy(semesters, (item) => {
    const [beforeColon, afterColon] = item.semester.split(':');
    return [parseInt(beforeColon, 10), parseInt(afterColon, 10)];
  });
};
